import { API } from "@/lib/api";
import { FileText, FileSpreadsheet, Download } from "lucide-react";
import { toast } from "sonner";

export default function Reports() {
  const download = async (format) => {
    try {
      const token = localStorage.getItem("dmcc_token");
      const url = `${API}/reports/${format}`;
      const resp = await fetch(url, { headers: { Authorization: `Bearer ${token}` } });
      if (!resp.ok) throw new Error("Failed");
      const blob = await resp.blob();
      const link = document.createElement("a");
      link.href = URL.createObjectURL(blob);
      link.download = `dmcc-report-${new Date().toISOString().slice(0,10)}.${format === "pdf" ? "pdf" : "xlsx"}`;
      document.body.appendChild(link);
      link.click();
      link.remove();
      toast.success(`Laporan ${format.toUpperCase()} berhasil diunduh`);
    } catch {
      toast.error("Gagal mengunduh laporan");
    }
  };

  return (
    <div className="p-6 lg:p-8 space-y-8 fade-in">
      <div className="pb-2 border-b border-[#1F1F1F]">
        <div className="label-mono">// exports & reports</div>
        <h1 className="font-display font-black text-4xl sm:text-5xl tracking-tighter mt-2" data-testid="reports-title">
          Laporan <span className="text-[#00F0FF]">Kinerja</span>
        </h1>
        <p className="text-zinc-500 text-sm mt-2">Unduh ringkasan kinerja lengkap dalam format PDF atau Excel.</p>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-4 max-w-3xl">
        <div className="border border-[#1F1F1F] bg-[#0A0A0A] p-6 space-y-4">
          <div className="w-12 h-12 border border-[#1F1F1F] bg-[#050505] flex items-center justify-center">
            <FileText size={24} className="text-[#FF3B30]" />
          </div>
          <div>
            <h3 className="font-display font-bold text-xl">Laporan PDF</h3>
            <p className="text-sm text-zinc-500 mt-1">Ringkasan visual formal, cocok untuk presentasi & rapat manajemen.</p>
          </div>
          <button onClick={() => download("pdf")}
            data-testid="download-pdf-btn"
            className="w-full py-3 bg-[#007AFF] hover:bg-[#0056b3] label-mono flex items-center justify-center gap-2 transition">
            <Download size={14} /> unduh pdf
          </button>
        </div>

        <div className="border border-[#1F1F1F] bg-[#0A0A0A] p-6 space-y-4">
          <div className="w-12 h-12 border border-[#1F1F1F] bg-[#050505] flex items-center justify-center">
            <FileSpreadsheet size={24} className="text-[#00E676]" />
          </div>
          <div>
            <h3 className="font-display font-bold text-xl">Laporan Excel</h3>
            <p className="text-sm text-zinc-500 mt-1">Data mentah per channel untuk analisis lanjutan di spreadsheet.</p>
          </div>
          <button onClick={() => download("excel")}
            data-testid="download-excel-btn"
            className="w-full py-3 border border-[#1F1F1F] hover:border-[#00E676] hover:text-[#00E676] label-mono flex items-center justify-center gap-2 transition">
            <Download size={14} /> unduh excel
          </button>
        </div>
      </div>

      <div className="max-w-3xl label-mono text-zinc-600">
        // laporan dibuat real-time berdasarkan data channel aktif saat ini
      </div>
    </div>
  );
}
